import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { IUser } from '../UserSlice';
import { adminGetStudents, adminLoadMoreStudents } from './AdminStudentsApi';

export interface IStudentsState {
  status: 'idle' | 'loading' | 'rejected';
  count: number;
  list: IUser[];
}

const initialState: IStudentsState = {
  status: 'idle',
  count: 0,
  list: [],
};

export const StudentsSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ADMIN GET STUDENTS LIST
      .addCase(adminGetStudents.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(adminGetStudents.fulfilled, (state, action) => {
        state.status = 'idle';
        state.count = action.payload.totalDocs;
        state.list = action.payload.docs || [];
      })
      .addCase(adminGetStudents.rejected, (state) => {
        state.status = 'rejected';
      })
      // ADMIN LOAD MORE STUDENTS LIST
      .addCase(adminLoadMoreStudents.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(adminLoadMoreStudents.fulfilled, (state, action) => {
        state.status = 'idle';
        state.count = action.payload.totalDocs;
        const newList = [...state.list, ...(action.payload.docs || [])];
        state.list = newList;
      })
      .addCase(adminLoadMoreStudents.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getStudentsState = (state: RootState): RootState['students'] =>
  state.students;

export * from './AdminStudentsApi';
export default StudentsSlice.reducer;
